import AddIcon from '@mui/icons-material/Add';
import { Box, ButtonBase, InputBase, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { themeSettings, tokens } from '../../../../theme';
import { useGetNotificationPreferencesQuery, useSendTestNotificationMutation, useUpdateNotificationPreferencesMutation } from '../../../../newapi/pwa/pwaSlice';
import { useSelector } from 'react-redux';
import Subheading from '../../../../components/theme/text/Subheading';
import Text from '../../../../components/theme/text/Text';
import ShSwitch from '../../../../components/theme/inputs/ShSwitch';
import Shbutton from '../../../../components/theme/buttons/Shbutton';
import { showToastMessageRequestError, showToastMessageUpdateRequest } from '../../../../utils/toasts';
import usePushNotifications from '../../../../hooks/usePushNotifications';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { UserPrivileges } from '../../../../utils/permissions';
import { selectUserPermission, isAdminUser } from '../../../../newapi/user/authentication/authSlice';
import { useGetSettingsQuery } from '../../../../newapi/global/generalApiSlice';
import { useGetRelationForMenuQuery } from '../../../../newapi/global/relation/relationSlice';
import { selectEnvironmentid } from '../../../../newapi/global/settingsSlice';
// import { useSelector } from "react-redux";
// import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
// import Shbutton from "../../../../../components/theme/buttons/Shbutton";
// import SidepanelLoader from '../../../../../components/theme/sidepanel2/SidepanelLoader';
// import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
// import { tokens } from "../../../../../theme";
// import { UserPrivileges } from '../../../../../utils/permissions';

// const SpStockDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpStockDetails/SPStockDetails"));
// const SPLocationDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpLocationDetails/SpLocationDetails"));
// const SPOrderDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));



let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};

const NotificationSetting = (props) => {
    const { t,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            sx={{
                display:"flex",
                alignItems:'center',
            }}
        >
            <Box
                sx={{
                    flex:2,
                }}
            >
                <Text light>{props.title}</Text>
            </Box>
            <Box
                sx={{
                    width:120,
                }}
            >
                <ShSwitch 
                    key={theme.palette.mode} 
                    checked={props.preferences?.[props.setting_key]} 
                    disabled={props.readOnly}
                    onChange={(event) => {
                        props.setPreferences(old => ({
                            ...old,
                            [props.setting_key]: event.target.checked
                        }))
                    }}
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                />
            </Box>
            <Box
                sx={{
                    width:80,
                    display:'flex',justifyContent:"flex-end",
                }}
            >
                <ShSwitch
                    key={theme.palette.mode} 
                    checked={props.preferences?.[props.setting_key+"_email"]} 
                    disabled={props.readOnly}
                    onChange={(event) => {
                        props.setPreferences(old => ({
                            ...old,
                            [props.setting_key+"_email"]: event.target.checked
                        }))
                    }}
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                />
            </Box>
        </Box>
    )
}

const NotificationSettings = (props) => {
    const { t } = useTranslation();

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === "RELATION";
    const isAdmin = useSelector(isAdminUser);
    const hasOrderActionRequiredPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.NOTIFICATION_ORDER_ACTION_REQUIRED])
    );
    const hasOrderNoPickstreamPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.NOTIFICATION_ORDER_NO_PICKSTREAM])
    );
    const hasStockBelowSafetyPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.NOTIFICATION_STOCK_BELOW_SAFETY])
    );
    const hasOrderStateChangePermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.NOTIFICATION_ORDER_MULTIPLE_STATE_OPEN_CHANGES])
    );
    const hasInvoiceReminderPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.NOTIFICATION_INVOICE_REMINDER])
    );
    const hasWebshopApprovalRequiredPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.NOTIFICATION_WEBSHOP_APPROVAL_REQUIRED])
    );
    const hasSupportTicketCreatedPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.NOTIFICATION_SUPPORT_TICKET_CREATED])
    );
    const hasSupportTicketReplyPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.NOTIFICATION_SUPPORT_TICKET_REPLY])
    );
    const hasSupportTicketAssignedPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.NOTIFICATION_SUPPORT_TICKET_ASSIGNED])
    );

    // Service desk notifications only make sense when the service desk is enabled.
    // Warehouse: gate on the global servicedesk_enabled flag + support permission.
    // Relation: additionally require the per-relation page_servicedesk right — mirrors
    // how the sidebar decides whether to surface the service desk at all.
    const selectedEnvironmentId = useSelector(selectEnvironmentid);
    const { data: servicedeskSettings } = useGetSettingsQuery("servicedesk");
    const servicedeskEnabled = !!servicedeskSettings?.some(
        (s) => s.key === "servicedesk_enabled" && (s.value === "true" || s.value === true)
    );
    const { data: relationMenuData } = useGetRelationForMenuQuery(selectedEnvironmentId, { skip: !isRelation });
    const relationServicedeskEnabled = !!relationMenuData?.settings?.some(
        (s) => s.key === "page_servicedesk" && s.value === "true"
    );
    const hasSupportPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.SUPPORT_READ, UserPrivileges.SUPPORT_MANAGE])
    );
    const hasRelationSupportPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.RP_SUPPORT_READ, UserPrivileges.RP_SUPPORT_MANAGE])
    );
    const showWarehouseServiceDesk = isFulfilment && servicedeskEnabled && (isAdmin || hasSupportPermission);
    const showRelationServiceDesk = isRelation && servicedeskEnabled && relationServicedeskEnabled && hasRelationSupportPermission;

    const hasReturnShipmentFailedPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.NOTIFICATION_RETURN_SHIPMENT_FAILED])
    );
    const [preferences, setPreferences] = useState({
        system: true,
        system_email: true,

        // Relation notifications
        order_in_backorder: false,
        order_in_backorder_email: false,
        order_in_maintenance: false,
        order_in_maintenance_email: false,
        order_not_imported: false,
        order_not_imported_email: false,
        stock_low: false,
        stock_low_email: false,
        inbound_completed: false,
        inbound_completed_email: false,
        inbound_incomplete_received: false,
        inbound_incomplete_received_email: false,
        export_ready: false,
        export_ready_email: false,
        return_processed: false,
        return_processed_email: false,
        relation_bbdate: false,
        relation_bbdate_email: false,
        relation_bbdate_quarantine: false,
        relation_bbdate_quarantine_email: false,
        bol_shipment_unconfirmed: false,
        bol_shipment_unconfirmed_email: false,
        order_multiple_state_open_changes:false,
        order_multiple_state_open_changes_email:false,
        relation_order_remark: false,
        relation_order_remark_email: false,
        return_no_all_products_received: false,
        return_no_all_products_received_email: false,
        return_shipment_failed: false,
        return_shipment_failed_email: false,

        // Warehouse notifications
        order_action_required_warehouse: false,
        order_action_required_warehouse_email: false,
        order_no_pickstream: false,
        order_no_pickstream_email: false,
        stock_below_safety: false,
        stock_below_safety_email: false,
        invoice_reminder: false,
        invoice_reminder_email: false,
        invoice_category_changed: false,
        invoice_category_changed_email: false,
        webshop_approval_required: false,
        webshop_approval_required_email: false,

        // Support ticket (service desk) notifications
        support_ticket_created: false,
        support_ticket_created_email: false,
        support_ticket_reply: false,
        support_ticket_reply_email: false,
        support_ticket_assigned: false,
        support_ticket_assigned_email: false,
        support_ticket_status_changed: false,
        support_ticket_status_changed_email: false,
    })

    const {data,isLoading,isFetching,isError} = useGetNotificationPreferencesQuery()
    const [updateNotificationPreferences, {isLoading:updatingPreferences}] = useUpdateNotificationPreferencesMutation();
    const [sendTestNotification,{isLoading:sendTestLoading}] = useSendTestNotificationMutation();
    // notificationType
    const {
        userSubscriptions,
        isSupported,
        subscription,
        permission,
        isLoading:notificationLoading,
        subscribeToPush,
        unsubscribeFromPush,
        subscribeLoading,
        unsubscribeLoading,
    } = usePushNotifications();
    const [deviceName, setDeviceName] = useState("");

    useEffect(() => {
        if(!isLoading && !isFetching) {
            if(data?.data) {
                setPreferences(data.data.preferences);
            }
        }
    }, [data,isLoading,isFetching])

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            // mobileActions: <GridActions handleOpen={handleOpen} hasCreatePermission={hasCreatePermission}></GridActions>,
        });

        return () => {
            
        }
    },[]);
    // console.log(navigator.serviceWorker.controller)

    return (
        <Box
            sx={{
                height:1,
                display:'flex',
                px:4,
                pt:4,
            }}
        >
            <Box
                sx={{
                    flex:1,
                    pr:4,
                    minWidth:400,
                }}
            >
                <Subheading>{t("notificationsettings")}</Subheading>
                <Box
                    sx={{
                        mt:3,
                        display:"flex",
                    }}
                >
                    <Text semibold sx={{flex:2}}>{t("notification_types")}</Text>
                    <Text semibold sx={{width:120}}>{t("notifications")}</Text>
                    <Text semibold sx={{width:80,display:'flex',justifyContent:"flex-end",pr:1,}}>{t("emails")}</Text>
                </Box>
                <Box
                    sx={{
                        mt:1,
                        display:"flex",
                        flexDirection:"column",
                    }}
                >
                    <NotificationSetting
                        title={t("system")}
                        readOnly
                        preferences={preferences}
                        setPreferences={setPreferences}
                        setting_key={"system"}
                    />

                    {/* Relation notifications */}
                    {isRelation && (
                        <>
                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("orders")}</Subheading>
                            <NotificationSetting
                                title={t("notification_order_in_backorder")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"order_in_backorder"}
                            />
                            <NotificationSetting
                                title={t("notification_order_in_maintenance")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"order_in_maintenance"}
                            />
                            <NotificationSetting
                                title={t("notification_order_not_imported")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"order_not_imported"}
                            />
                            <NotificationSetting
                                title={t("relation_order_remark")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"relation_order_remark"}
                            />
                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("shipments")}</Subheading>
                            <NotificationSetting
                                title={t("bol_shipment_unconfirmed")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"bol_shipment_unconfirmed"}
                            />

                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("stock")}</Subheading>
                            <NotificationSetting
                                title={t("notification_stock_low")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"stock_low"}
                            />
                            <NotificationSetting
                                title={t("notification_relation_bbdate")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"relation_bbdate"}
                            />
                            <NotificationSetting
                                title={t("notification_relation_bbdate_quarantine")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"relation_bbdate_quarantine"}
                            />

                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("inbound")}</Subheading>
                            <NotificationSetting
                                title={t("notification_inbound_completed")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"inbound_completed"}
                            />
                            <NotificationSetting
                                title={t("notification_inbound_incomplete_received")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"inbound_incomplete_received"}
                            />

                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("exports")}</Subheading>
                            <NotificationSetting
                                title={t("notification_export_ready")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"export_ready"}
                            />

                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("returns")}</Subheading>
                            <NotificationSetting
                                title={t("notification_return_processed")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"return_processed"}
                            />
                            <NotificationSetting
                                title={t("notification_return_no_all_products_received")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"return_no_all_products_received"}
                            />
                            <NotificationSetting
                                title={t("notification_return_shipment_failed")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"return_shipment_failed"}
                            />
                        </>
                    )}

                    {/* Warehouse non-fulfilment notifications */}
                    {!isRelation && !isFulfilment && (
                        <>
                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("orders")}</Subheading>
                            <NotificationSetting
                                title={t("notification_order_in_backorder")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"order_in_backorder"}
                            />
                            <NotificationSetting
                                title={t("notification_order_in_maintenance")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"order_in_maintenance"}
                            />
                            <NotificationSetting
                                title={t("notification_order_not_imported")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"order_not_imported"}
                            />
                            <NotificationSetting
                                title={t("notification_order_no_pickstream")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"order_no_pickstream"}
                            />

                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("stock")}</Subheading>
                            <NotificationSetting
                                title={t("notification_stock_low")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"stock_low"}
                            />
                            <NotificationSetting
                                title={t("notification_stock_below_safety_carriers")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"stock_below_safety"}
                            />

                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("exports")}</Subheading>
                            <NotificationSetting
                                title={t("notification_export_ready")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"export_ready"}
                            />
                        </>
                    )}

                    {/* Warehouse notifications */}
                    {isFulfilment && (isAdmin || hasOrderActionRequiredPermission || hasOrderNoPickstreamPermission || hasOrderStateChangePermission) && (
                        <>
                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("orders")}</Subheading>
                            {(isAdmin || hasOrderActionRequiredPermission) && (
                                <NotificationSetting
                                    title={t("notification_order_action_required_warehouse")}
                                    readOnly={false}
                                    preferences={preferences}
                                    setPreferences={setPreferences}
                                    setting_key={"order_action_required_warehouse"}
                                />
                            )}
                            {(isAdmin || hasOrderNoPickstreamPermission) && (
                                <NotificationSetting
                                    title={t("notification_order_no_pickstream")}
                                    readOnly={false}
                                    preferences={preferences}
                                    setPreferences={setPreferences}
                                    setting_key={"order_no_pickstream"}
                                />
                            )}
                            {(isAdmin || hasOrderStateChangePermission) && (
                                <NotificationSetting
                                    title={t("notification_order_multiple_state_open_changes")}
                                    readOnly={false}
                                    preferences={preferences}
                                    setPreferences={setPreferences}
                                    setting_key={"order_multiple_state_open_changes"}
                                />
                            )}
                        </>
                    )}

                    {isFulfilment && (isAdmin || hasStockBelowSafetyPermission) && (
                        <>
                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("stock")}</Subheading>
                            <NotificationSetting
                                title={t("notification_stock_below_safety")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"stock_below_safety"}
                            />
                        </>
                    )}

                    {isFulfilment && (isAdmin || hasInvoiceReminderPermission) && (
                        <>
                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("financial")}</Subheading>
                            <NotificationSetting
                                title={t("notification_invoice_reminder")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"invoice_reminder"}
                            />
                            <NotificationSetting
                                title={t("notification_invoice_category_changed")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"invoice_category_changed"}
                            />
                        </>
                    )}

                    {isFulfilment && (isAdmin || hasWebshopApprovalRequiredPermission) && (
                        <>
                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("webshop")}</Subheading>
                            <NotificationSetting
                                title={t("notification_webshop_approval_required")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"webshop_approval_required"}
                            />
                        </>
                    )}

                    {/* Service desk notifications (fulfilment): created, reply, assigned.
                        Each row additionally requires its own notification right. */}
                    {showWarehouseServiceDesk &&
                        (isAdmin ||
                            hasSupportTicketCreatedPermission ||
                            hasSupportTicketReplyPermission ||
                            hasSupportTicketAssignedPermission) && (
                        <>
                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("servicedesk")}</Subheading>
                            {(isAdmin || hasSupportTicketCreatedPermission) && (
                                <NotificationSetting
                                    title={t("notification_support_ticket_created")}
                                    readOnly={false}
                                    preferences={preferences}
                                    setPreferences={setPreferences}
                                    setting_key={"support_ticket_created"}
                                />
                            )}
                            {(isAdmin || hasSupportTicketReplyPermission) && (
                                <NotificationSetting
                                    title={t("notification_support_ticket_reply")}
                                    readOnly={false}
                                    preferences={preferences}
                                    setPreferences={setPreferences}
                                    setting_key={"support_ticket_reply"}
                                />
                            )}
                            {(isAdmin || hasSupportTicketAssignedPermission) && (
                                <NotificationSetting
                                    title={t("notification_support_ticket_assigned")}
                                    readOnly={false}
                                    preferences={preferences}
                                    setPreferences={setPreferences}
                                    setting_key={"support_ticket_assigned"}
                                />
                            )}
                        </>
                    )}

                    {/* Service desk notifications (relation): reply, status changed */}
                    {showRelationServiceDesk && (
                        <>
                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("servicedesk")}</Subheading>
                            <NotificationSetting
                                title={t("notification_support_ticket_reply")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"support_ticket_reply"}
                            />
                            <NotificationSetting
                                title={t("notification_support_ticket_status_changed")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"support_ticket_status_changed"}
                            />
                        </>
                    )}

                    {isFulfilment && !isRelation && (isAdmin || hasReturnShipmentFailedPermission) && (
                        <>
                            <Subheading sx={{ mt: 2, mb: 1 }}>{t("returns")}</Subheading>
                            <NotificationSetting
                                title={t("notification_return_shipment_failed")}
                                readOnly={false}
                                preferences={preferences}
                                setPreferences={setPreferences}
                                setting_key={"return_shipment_failed"}
                            />
                        </>
                    )}
                </Box>
                <Shbutton
                    isLoading={updatingPreferences}
                    onClick={async () => {
                        if(updatingPreferences) return;
                        try{
                            const data = await updateNotificationPreferences({preferences:preferences}).unwrap();
                            showToastMessageUpdateRequest(t,data);
                        } catch(err) {
                            showToastMessageRequestError(t("update_failed"),t, err);
                        }
                    }}
                    sx={{
                        mt:3,
                    }}
                    color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                    block
                    variant={"contained"}
                >
                    {t("save")}
                </Shbutton>
            </Box>

            <Box 
                sx={{
                    flex:2,
                    background:colors.bg["tertiary"],
                    borderTopLeftRadius:24,
                    borderTopRightRadius:24,
                    p:3,
                }}
            >
                {isSupported && (!subscription || !userSubscriptions?.data?.some(sub => sub.endpoint === subscription.endpoint)) &&
                    <Box
                        sx={{
                            mb:3,
                        }}
                    >
                        <Subheading>{t("current_device_not_subscribed")}</Subheading>
                        <Box
                            sx={{
                                mt:1,
                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                py:1.5,
                                pl:1.5,
                                pr:1.5,
                                borderRadius:8,
                                display:"flex",
                                gap:2,
                            }}
                        >
                            <Box
                                sx={{
                                    height:32,
                                    flex:1,
                                    background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100],
                                    borderRadius:4,
                                    display:"flex",
                                    alignItems:"center",
                                    pl:0.5,
                                }}
                            >
                                <Box
                                    sx={{

                                        height:24,
                                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                        px:1,
                                        borderRadius:3,
                                    }}
                                >
                                    <Text>{t("device_name")}</Text>
                                </Box>
                                <InputBase
                                    value={deviceName}
                                    onChange={(event) => setDeviceName(event.target.value)}
                                    sx={{
                                        pl:1.5,
                                        height:32,
                                        lineHeight:"32px",
                                        flex:1,
                                        fontSize:14,
                                    }}
                                />

                            </Box>
                            <Shbutton 
                                isLoading={subscribeLoading}
                                size={"32"}
                                variant={"contained"}
                                onClick={() => subscribeToPush(deviceName)}
                                disabled={deviceName.length === 0}
                                color={theme.palette.mode === "dark" ? "blue" : "primary"}
                            
                            >{t("subscribe")}</Shbutton>
                        </Box>
                    </Box>
                }
                {userSubscriptions?.data.length > 0 &&
                    <Box>
                        <Subheading>{t("subscribed_devices")}</Subheading>
                        <Box>
                            {userSubscriptions?.data?.map((sub,idx) => (
                                <Box
                                    key={"sub"+idx}
                                    sx={{
                                        mt:1,
                                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                        py:1.5,
                                        pl:3,
                                        pr:1.5,
                                        borderRadius:8,
                                        display:"flex",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            height:32,
                                            flex:1,
                                            display:"flex",
                                            alignItems:"center",
                                            gap:1,
                                            
                                        }}
                                    >
                                        <Text semibold>{sub.deviceName}</Text>
                                        {sub?.endpoint === subscription?.endpoint &&
                                            <Text light italic>({t("current_device")})</Text>
                                        }
                                    </Box>
                                    {/* <Shbutton 
                                        size={"32"}
                                        variant={"contained"}
                                        // onClick={() => subscribeToPush(deviceName)}
                                        // disabled={deviceName.length === 0}
                                        color={theme.palette.mode === "dark" ? "blue" : "primary"}

                                    >{t("unsubscribe")}</Shbutton> */}
                                    <Shbutton 
                                        size={"32"}
                                        variant={"contained"}
                                        isLoading={sendTestLoading}
                                        onClick={() => sendTestNotification({notificationType:"system"})}
                                        // disabled={deviceName.length === 0}
                                        color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                                        sx={{
                                            ml:2,
                                        }}
                                    >
                                        {t("send_testnotification")}
                                    </Shbutton>
                                    <ButtonBase
                                        disabled={unsubscribeLoading}
                                        onClick={unsubscribeFromPush}
                                        sx={{
                                            width:32,
                                            height:32,
                                            flexShrink:0,
                                            borderRadius:4,
                                            background:themeSettings(theme.palette.mode).palette.red.main,
                                            color:themeSettings(theme.palette.mode).palette.red.contrastText,
                                            fontWeight:700,
                                            ml:1,
                                        }}
                                    >
                                        <DeleteOutlineOutlinedIcon/>
                                    </ButtonBase>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                }
                
                {/* ewf */}
            </Box>
        </Box>
    );
}
export default NotificationSettings;